import { seoArticles } from '@/mocks/articles';

export default function SeoArticlesGrid() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 lg:px-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-medium text-primary-600 uppercase tracking-widest mb-3">
            Articoli SEO
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            Guide e Approfondimenti Itaobuy Sheet
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            Scopri le nostre guide dettagliate per sfruttare al massimo lo spreadsheet itaobuy
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {seoArticles.map((article) => (
            <a
              key={article.id}
              href={article.slug}
              className="group bg-background-100 rounded-2xl overflow-hidden cursor-pointer hover:scale-[1.02] transition-all duration-300 flex flex-col"
            >
              <div className="relative overflow-hidden aspect-[3/2]">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-background-50/90 backdrop-blur-sm text-foreground-700 text-xs font-medium">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base mb-2.5 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed mb-4 line-clamp-3 flex-1">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between pt-3 border-t border-background-200">
                  <span className="text-xs text-foreground-400">{article.readTime} di lettura</span>
                  <span className="flex items-center gap-1 text-xs font-medium text-primary-600">
                    Leggi <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="/guida-itaobuy-spreadsheet"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-background-300 text-foreground-700 font-medium text-sm hover:border-primary-400 hover:text-primary-600 transition-all cursor-pointer whitespace-nowrap"
          >
            <span>Vedi tutte le guide</span>
            <i className="ri-arrow-right-line text-base"></i>
          </a>
        </div>
      </div>
    </section>
  );
}